// Reusable popsicle SVG used in the Dream Pops Builder and Hero
import { motion } from "framer-motion";

export default function PopsicleSVG({
  primary = "#FF4F5A",
  secondary = "#FFC93C",
  shape = "classic",
  className = "",
  animate = true,
}) {
  // Render different shape outlines
  const bodyPath = (() => {
    switch (shape) {
      case "rocket":
        return "M50,12 C70,12 80,32 80,56 V120 C80,140 60,150 50,150 C40,150 20,140 20,120 V56 C20,32 30,12 50,12 Z";
      case "twin":
        return "M16,18 H44 C50,18 52,22 52,30 V134 C52,144 46,150 38,150 H22 C14,150 8,144 8,134 V30 C8,22 10,18 16,18 Z M56,18 H84 C90,18 92,22 92,30 V134 C92,144 86,150 78,150 H62 C54,150 48,144 48,134 V30 C48,22 50,18 56,18 Z";
      case "heart":
        return "M50,18 C70,8 88,24 84,46 C80,72 50,128 50,128 C50,128 20,72 16,46 C12,24 30,8 50,18 Z";
      case "moulded":
        return "M50,16 C75,16 88,38 88,68 C88,108 70,140 50,140 C30,140 12,108 12,68 C12,38 25,16 50,16 Z";
      default:
        return "M30,14 H70 C76,14 82,20 82,30 V128 C82,140 76,150 60,150 H40 C24,150 18,140 18,128 V30 C18,20 24,14 30,14 Z";
    }
  })();

  return (
    <motion.svg
      viewBox="0 0 100 180"
      className={className}
      animate={animate ? { rotate: [-3, 3, -3] } : undefined}
      transition={animate ? { duration: 6, repeat: Infinity, ease: "easeInOut" } : undefined}
    >
      <defs>
        <linearGradient id="popGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={primary} />
          <stop offset="100%" stopColor={secondary} />
        </linearGradient>
        <filter id="popShadow" x="-30%" y="-10%" width="160%" height="140%">
          <feDropShadow dx="0" dy="6" stdDeviation="6" floodOpacity="0.18" />
        </filter>
      </defs>
      {/* stick */}
      <rect x="44" y="138" width="12" height="40" rx="3" fill="#C7A37A" />
      <rect x="44" y="138" width="12" height="6" rx="3" fill="#A07F58" />
      {/* body */}
      <path d={bodyPath} fill="url(#popGrad)" filter="url(#popShadow)" />
      {/* highlight */}
      <path d="M30,30 C28,60 30,100 32,120" stroke="rgba(255,255,255,0.4)" strokeWidth="4" strokeLinecap="round" fill="none" />
      {/* drip */}
      <path d="M70,30 C68,40 74,46 72,56" stroke="rgba(255,255,255,0.25)" strokeWidth="3" strokeLinecap="round" fill="none" />
    </motion.svg>
  );
}
